import { useState, useCallback } from 'react';
import { message } from 'antd';
import { pw930bApi, QueryParams, DeptStats, CompanyTotals } from '../../../services/pw930bApi';

export function usePW930BQuery() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<DeptStats[]>([]);
  const [totals, setTotals] = useState<CompanyTotals | null>(null);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);

  const runQuery = useCallback(async (params: QueryParams) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await pw930bApi.query(params);
      if (resp.data && resp.data.length > 0) {
        setData(resp.data);
        setTotals(resp.totals);
        setNoData(false);
      } else {
        setData([]);
        setTotals(null);
        setNoData(true);
        message.info(resp.message || '查無符合條件的部門資料!');
      }
      setQueried(true);
    } catch {
      message.error('查詢失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setData([]);
    setTotals(null);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, data, totals, queried, noData, runQuery, reset };
}
